import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { ClientNotificationHandlerService, TagsDataConfig } from '@thehubz/client/core';
import { TagsApiService } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';

@Component({
  selector: 'thehubz-cumulated-tags-chip',
  templateUrl: './cumulated-tags-chip.component.html',
  styleUrls: ['./cumulated-tags-chip.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatInputModule, MatChipsModule, MatDividerModule, MatMenuModule],
})
export class CumulatedTagsChipComponent {
  /** Tag data */
  @Input() tagData!: TagsDataConfig;
  /** Tags Observable*/
  @Input() tagsObs!: AnyType;
  /** Store filtered tag list from the search input */
  toggleEditSelectedTag = false;
  /** Bind with edit tag input field */
  tagName = '';
  /** Toggle the edit tag */
  toggleEditTag = false;
  /** Store current editing tag id */
  editingTag = '';

  @Output() updateTagObject = new EventEmitter<AnyType>();
  @Output() addTagToList = new EventEmitter<AnyType>();
  @ViewChild('renameInput') renameInput?: ElementRef<HTMLInputElement>;
  @ViewChild('renameSearchInput') renameSearchInput?: ElementRef<HTMLInputElement>;

  constructor(private tagsApiService: TagsApiService, private clientNotificationHandlerService: ClientNotificationHandlerService) {}

  /**
   * Update tag name and call update api
   * @param index
   */
  saveTagName(tagsId: string, index: number) {
    this.tagsApiService.tagsControllerUpdate(tagsId, { name: this.tagName }).subscribe(() => {
      if (this.tagsObs[index]) {
        this.tagsObs[index].name = this.tagName;
      }
      this.updateTagObject.emit(this.tagsObs);
    });
    this.toggleEditTag = false;
    this.toggleEditSelectedTag = false;
  }

  /**
   * Close rename tag input field
   */
  exitRenameTag() {
    this.toggleEditTag = false;
    this.toggleEditSelectedTag = false;
    this.editingTag = '';
  }

  /**
   * Toggle tag for renaming it
   * @param index
   */
  renameTag(index: number) {
    this.toggleEditTag = true;
    this.toggleEditSelectedTag = false;
    const tag = this.tagsObs[index];
    // assign the current name to the tabName input
    this.tagName = tag.name;
    this.editingTag = tag._id;
    setTimeout(() => {
      this.renameInput?.nativeElement?.focus();
      this.renameInput?.nativeElement?.select();
    }, 0);
  }

  /**
   * Toggle tag for renaming it
   * @param index
   */
  removeTagFromAllAssets(index: number) {
    this.addTagToList.emit({ selectedTagName: '' });
    this.tagsObs.splice(index, 1);
    this.updateTagObject.emit(this.tagsObs);
  }

  /**
   * Toggle tag for renaming it
   * @param index
   */
  addTagToAllAssets(index: number) {
    const tag = this.tagsObs[index];
    const tagName = tag.name;
    this.addTagToList.emit({ selectedTagName: tagName });
    this.tagsObs.splice(index, 1);
    this.updateTagObject.emit(this.tagsObs);
  }
}
